import * as Yup from "yup";

export const AadhaarSchema = Yup.object().shape({
  aadhaar: Yup.string()
    .required("Aadhaar number is required")
    .test("is-valid-aadhaar", "Aadhaar must be exactly 12 digits", (value) => {
      if (!value) return false;
      const digits = value.replace(/\D/g, ""); // remove hyphens, spaces
      return /^\d{12}$/.test(digits);
    }),
  consent: Yup.boolean()
    .required("Consent is required")
    .oneOf([true], "You must agree before proceeding"),
});

export const OtpSchema = Yup.object().shape({
  otp: Yup.string()
    .matches(/^\d{5}$/, "OTP must be exactly 5 digits")
    .required("OTP is required"),
});

// export const GstSchema = Yup.object().shape({
//   gstNumber: Yup.string()
//     .matches(
//       /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
//       "Invalid GST number"
//     )
//     .required("GST number is required"),
// });
export const SubmitValidationSchema = Yup.object().shape({
  userCategory: Yup.number()
    .required("Category is required")
    .oneOf([1, 2], "Invalid category"),

  gstNumber: Yup.string()
    .matches(/^[a-zA-Z0-9]*$/, "GST number must be alphanumeric")
    .max(15, "GST number must not exceed 15 characters")
    .when("userCategory", {
      is: 2,
      then: schema => schema.required("GST Number is required"),
      otherwise: schema => schema.notRequired(),
    }),

  email: Yup.string()
    .email("Invalid email format")
    // .test("email-validation", "Email is required", function(value) {
    //   // If email is being edited or has a value, it must be valid
    //   if (value && value.trim() !== "") {
    //     return true; // email format will be validated by .email() above
    //   }
    //   // Email is optional if blank initially, but required if user starts editing
    //   return true; // Allow blank email for now
    // }),
});


export const OrganisationDetailsSchema = Yup.object().shape({
  cin: Yup.string().required("CIN Number is required"),
  tin: Yup.string()
    .required("TIN Number is required")
    .matches(/^[a-zA-Z0-9]+$/, "Only alphanumeric characters allowed"),
});
